import { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/shared/lib';
import { CopyButton } from '../CopyButton/CopyButton';

type Props = {
  /** Значение, уходящее в буфер обмена; при пустом кнопка не рисуется */
  text: string | null;
  /** Содержимое ячейки, показанное пользователю */
  children: ReactNode;
  /** Кнопки ячейки левее копирования; показываются по тем же правилам */
  actions?: ReactNode;
  /** Значение переносится по строкам, а не усекается в одну: перенос задаёт само содержимое */
  isContentWrapped?: boolean;
  className?: string;
};

/** Содержимое ячейки таблицы: показанное значение и кнопка копирования его текста. */
export const CopyableCell: FC<Props> = ({ text, children, actions, isContentWrapped, className }) => {
  const { t } = useTranslation('common');

  return (
    <div className={cn('relative flex w-full min-w-0 items-center', className)}>
      <div className={cn('min-w-0 flex-1', isContentWrapped ? 'whitespace-normal' : 'truncate')}>{children}</div>
      {(text || actions) && (
        <div className="absolute right-0 flex items-center opacity-0 transition-opacity group-hover/copy-cell:opacity-100 has-[:focus-visible]:opacity-100">
          {actions}
          {text && <CopyButton text={text} tooltip={t('copy')} className="size-6" />}
        </div>
      )}
    </div>
  );
};
